import { c as _c } from "react/compiler-runtime";
import { CheckCircleSolid } from '@byway/icons';
import clsx from 'clsx';
import { ToggleButton as RACToggleButton } from 'react-aria-components';
import styles from './ToggleButton.module.css';
import type { ToggleButtonProps } from './ToggleButton.types';
export function ToggleButton(t0) {
  const $ = _c(16);
  let isElevated;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isElevated,
      showToggleIndicator: t1,
      variant: t2,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = isElevated;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    isElevated = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const showToggleIndicator = t1 === undefined ? true : t1;
  const variant = t2 === undefined ? "default" : t2;
  const t3 = variant === "pill";
  const t4 = variant === "segmented";
  let t5;
  if ($[5] !== isElevated || $[6] !== t3 || $[7] !== t4) {
    t5 = clsx(styles.toggleButton, {
      [styles.isElevated]: isElevated,
      [styles.pill]: t3,
      [styles.segmented]: t4
    });
    $[5] = isElevated;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== props.children || $[10] !== showToggleIndicator) {
    t6 = renderProps => {
      const isSelected = renderProps.state.isSelected;
      return <>{showToggleIndicator && <div className={styles.circleContainer}>{isSelected ? <CheckCircleSolid size="scale" decorative={true} /> : <div className={styles.emptyCircle} />}</div>}{props.children}</>;
    };
    $[9] = props.children;
    $[10] = showToggleIndicator;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== props || $[13] !== t5 || $[14] !== t6) {
    t7 = <RACToggleButton className={t5} {...props}>{t6}</RACToggleButton>;
    $[12] = props;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}